import { Switch } from '../ui/switch';
import { Label } from '../ui/label';
import { Slider } from '../ui/slider';
import { Mountain } from 'lucide-react';

export const HighGuardSettings = ({ editSettings, setEditSettings }) => {
  const set = (patch) => setEditSettings({ ...editSettings, ...patch });
  return (
    <div className="p-4 border border-[#003B00] space-y-3" data-testid="high-guard-settings">
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center gap-2 flex-shrink-0">
          <Mountain className="h-4 w-4 text-red-400" />
          <Label className="text-[#008F11] text-sm uppercase">{editSettings.high_guard_days}-Day High Guard</Label>
        </div>
        <Switch
          checked={editSettings.high_guard_enabled}
          onCheckedChange={(checked) => set({ high_guard_enabled: checked })}
          className="data-[state=checked]:bg-red-500"
          data-testid="high-guard-toggle"
        />
      </div>
      <p className="text-xs text-gray-500">
        Don't buy near the top. Skips every automatic buy when the price is within X% of the coin's recent high. Sells still work.
      </p>
      {editSettings.high_guard_enabled && (
        <div className="space-y-3">
          <div className="flex justify-between">
            <span className="text-xs text-[#008F11]">Block buys within</span>
            <span className="text-red-400 font-bold" data-testid="high-guard-percent-value">{editSettings.high_guard_percent}% of high</span>
          </div>
          <Slider
            value={[editSettings.high_guard_percent]}
            onValueChange={([value]) => set({ high_guard_percent: value })}
            min={1}
            max={50}
            step={1}
            className="[&_[role=slider]]:bg-red-400"
            data-testid="high-guard-percent-slider"
          />
          <div className="flex justify-between">
            <span className="text-xs text-[#008F11]">Lookback window</span>
            <span className="text-red-400 font-bold" data-testid="high-guard-days-value">{editSettings.high_guard_days} days</span>
          </div>
          <Slider
            value={[editSettings.high_guard_days]}
            onValueChange={([value]) => set({ high_guard_days: value })}
            min={7}
            max={300}
            step={1}
            className="[&_[role=slider]]:bg-red-400"
            data-testid="high-guard-days-slider"
          />
          <p className="text-xs text-[#008F11]">
            Bot holds instead of buying if price ≥ {100 - editSettings.high_guard_percent}% of the {editSettings.high_guard_days}-day high.
          </p>
        </div>
      )}
    </div>
  );
};
